import { render, staticRenderFns } from "./xlsAdvSol.vue?vue&type=template&id=581da0e0&scoped=true&"
import script from "./xlsAdvSol.vue?vue&type=script&lang=js&"
export * from "./xlsAdvSol.vue?vue&type=script&lang=js&"
import style0 from "./xlsAdvSol.vue?vue&type=style&index=0&id=581da0e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581da0e0",
  null
  
)

export default component.exports